<template>
  <button
    :disabled="disabled"
    :class="[
      variant === 'text' && {
        'border-none bg-lighter-grey-2 text-regular-grey fill-regular-grey !cursor-default': disabled,
        'shadow-button-pressed bg-primary-00 text-primary-10 fill-primary-10 border-primary-10': !disabled && active,
        '[&>svg-icon:w-24px] hover:text-primary-10 hover:fill-primary-10 active:shadow-active-button  cursor-pointer':
          !disabled,
        'text-soft-grey fill-inactive border-none bg-transparent': !disabled && !active,
      },
      variant === 'outlined' && {
        'shadow-button-pressed bg-primary-0 text-primary-10 fill-primary-10 border-primary-10': !disabled && active,
        'text-soft-grey fill-inactive border-regular-grey hover:border-primary-10 bg-white': !disabled && !active,
        'border-grey-2 !bg-gray-1 text-regular-grey fill-regular-grey !cursor-not-allowed': disabled,
        '[&>svg-icon:w-24px] hover:text-primary-10 hover:fill-primary-10 active:fill-primary-10 hover:border-primary-10 active:shadow-active-button] active:bg-primary-0 focus:border-primary-4 focus:outline-[3px] focus:outline focus:outline-primary-4  cursor-pointer':
          !disabled,
      },
      variant === 'filled' && {
        '!border-none': true,
        '[&>svg-icon:w-24px] focus:outline-[3px] focus:outline  cursor-pointer': !disabled,
        'text-white bg-primary-10 hover:bg-primary-8 fill-white focus:outline-primary-4':
          color === 'primary' && !disabled,
        'text-white bg-papaya-10 hover:bg-papaya-8 focus:outline-papaya-6': color === 'papaya',
        'border-grey-2 !bg-gray-1 text-regular-grey fill-regular-grey !cursor-not-allowed': disabled,
        'text-gray-6 bg-pear-2 hover:bg-pear-6 focus:outline-pear-6 ': color === 'pear',
      },
      {
        'w-full text-center justify-center': fit,
        'rounded-20': rounded,
        'rounded-8': !rounded,
        'h-40px py-8px text-18 font-600 px-24px': size === 40,
        'h-32px py-6px text-16 font-600': size === 32,
        'active:shadow-button-pressed focus-visible:shadow-focus': !disabled,
      },
      'custom-button border-solid border-1 flex items-center px-16px user-select-none text-16',
      buttonClass,
    ]"
    @click="onClick"
    @keyup.enter="onEnterKeyup"
  >
    <BaseIconSVG v-if="loading" name="loading-static" class="mr-8px animate-spin" />
    <slot></slot>
  </button>
</template>

<script>
import BaseIconSVG from '../DataDisplay/BaseIconSVG.vue'

export default {
  name: 'BaseButton',
  components: { BaseIconSVG },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: 'outlined',
    },
    color: {
      type: String,
      default: 'primary',
    },
    buttonClass: {
      type: [String, Object],
      default: '',
    },
    fit: {
      type: Boolean,
      default: false,
    },
    rounded: {
      type: Boolean,
      default: true,
    },
    size: {
      type: Number,
      default: 32,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClick($event) {
      if (!this.disabled) {
        this.$emit('click')
      }
    },
    onEnterKeyup() {
      if (!this.disabled) {
        this.$emit('click')
      }
    },
  },
}
</script>

<style lang="scss"></style>
